import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../hooks/ReduxHooks";

interface IProtectedRoutesProps {}

const ProtectedRoutes: FC<IProtectedRoutesProps> = () => {
  const operator = useAppSelector((state) => state.user.operator);
  return operator ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
